<template>
  <div>
    <OurServices />
    <OurServicesGrid />
  </div>
</template>

<script>
import OurServices from '@/components/OurServices'
import OurServicesGrid from '@/components/OurServicesGrid'

export default {
  components: {
    OurServices,
    OurServicesGrid
  }
}
</script>

<style></style>
